import { motion } from 'framer-motion';
import moilustracao_infograficockup from '../../Assets/ilustracao_infografico.png';
import * as S from './Challenge.style';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};

export const Challenge = () => {
  return (
    <S.Wrapper>
      <S.ContentBox
        as={motion.div}
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
      >
        <div className="w-full md:w-[467px] lg:w-[50%] xl:w-[80%]">
          <S.Title
            as={motion.h1}
            variants={item}
          >
            VOCÊ ENFRENTA DESAFIOS LOGÍSTICOS COMO ESTES?
          </S.Title>

          <S.Text
            as={motion.ul}
          >
            {[
              'Altos custos operacionais.',
              'Falta de visibilidade em tempo real.',
              'Longas filas de carga e descarga.',
              'Comunicação ineficaz com motoristas.',
              'Gestão limitada de pátios e docas.',
              'Dificuldade na integração com sistemas fiscais e ERPs.',
            ].map((text, index) => (
              <motion.li key={index} variants={item}>
                {text}
              </motion.li>
            ))}
          </S.Text>

          <S.Btn
            as={motion.button}
            variants={item}
          >
            SAIBA COMO RESOLVER
          </S.Btn>
        </div>

        <S.Image
          src={moilustracao_infograficockup}
          alt="mockup"
        />
      </S.ContentBox>
    </S.Wrapper>
  );
};
